import { Controller } from "@hotwired/stimulus"
import { Current } from "current.js"

export default class extends Controller {
  track(event) {
    const raw = Current.gids
    const gids = typeof raw === 'string' && raw.length > 0 ? raw.split(',') : []
    window.ahoy.trackView(gids.length > 0 ? { gids } : {})
  }
}
